import { render, staticRenderFns } from "./reset.vue?vue&type=template&id=7e530085&lang=pug&"
import script from "./reset.vue?vue&type=script&lang=js&"
export * from "./reset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e530085')) {
      api.createRecord('7e530085', component.options)
    } else {
      api.reload('7e530085', component.options)
    }
    module.hot.accept("./reset.vue?vue&type=template&id=7e530085&lang=pug&", function () {
      api.rerender('7e530085', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/password_reset/reset.vue"
export default component.exports